import React from 'react'
import ReactDOM from 'react-dom'
import { inject, observer } from 'mobx-react'
import { get } from 'lodash'
import { createBrowserHistory } from 'history'
import { syncHistoryWithStore } from 'mobx-react-router'
import { Provider } from 'mobx-react'
import { App } from './app'
import { config } from './config/config'
import { createStore } from './stores/store'
import { getStore } from './stores/stores-repository'

import { RoutingStore } from './stores/routing-store'
import { Router, Route, Redirect, RedirectProps, Switch } from 'react-router-dom'
import {
    NOT_FOUND,
    REGISTRATION_SUCCESS,
} from './domain/routes'
import { PageContainer } from './components/page-container'
import { NotFound } from './components/not-found'
import { CrystalsAppContainer } from '@crystalservice/crystals-ui/lib/components/crystals-app-container/crystals-app-container'
import { createTheme } from './theme'

// TODO без этого русская локаль не пробрасывается
// а если то же самое сделать в crystals-ui, то не компилится
// версии момента одинаковые
import 'moment/locale/ru'

import './index.scss'
import { prepareLocale } from './utils/locale-util'
import { AppStore } from './stores/app-store'
import { BaseHttpService } from './protocol/base-http-service'
import { getGeneralErrorMiddleware } from './service-middlewares'
import { RegistrationPage } from './pages/registration/registration-page'
import { RegistrationStore } from './stores/registration-store'
import { RegistrationSuccess } from './pages/registration/registration-success'
import { LinkVerification } from './pages/registration/link-verification'
import { Unsubscribe } from './pages/registration/unsubscribe'
import { SetCaptchaStore } from './stores/set-captcha-store'

async function startApp(): Promise<void> {
    const store = createStore()

    await prepareLocale()

    if (!config.isProduction) {
        window['store'] = store // for debug reasons
    }

    if (config.isProduction) {
        await config.fillFromProdConfig()
    }

    /* queryString params overrides config.json params */
    config.fillFromUrlParams()

    /* develop.config.json params overrides queryString params in dev mode */
    if (!config.isProduction) {
        await config.fillFromDevelopConfig()  // for debug reasons
    }

    getStore<RegistrationStore>(RegistrationStore.storeName).init(config.serverUrl)
    getStore<SetCaptchaStore>(SetCaptchaStore.storeName).init(config.serverUrl)

    const history = syncHistoryWithStore(createBrowserHistory(), getStore<RoutingStore>(RoutingStore.storeName))

    BaseHttpService.generalErrorMiddlewares.push(getGeneralErrorMiddleware())

    ReactDOM.render(
        <Provider {...store}>
            <Router history={history}>
                <CrystalsAppContainer
                    theme={createTheme()}
                    localeSettings={{
                        initializeLib: false,
                        lng: getStore<AppStore>(AppStore.storeName).locale
                    }}
                >
                    <App>
                        <Switch>
                            <Route exact path="/:clientId/:channelId" >
                                <PageContainer>
                                    <RegistrationPage />
                                </PageContainer>
                            </Route>

                            <Route exact path={REGISTRATION_SUCCESS}>
                                <PageContainer>
                                    <RegistrationSuccess />
                                </PageContainer>
                            </Route>

                            <Route exact path="/confirm/id/:linkId">
                                <PageContainer>
                                    <LinkVerification />
                                </PageContainer>
                            </Route>

                            <Route exact path="/:clientId/unsubscribe/:encodedData">
                                <PageContainer>
                                    <Unsubscribe />
                                </PageContainer>
                            </Route>

                            <Route exact path={NOT_FOUND} >
                                <NotFound />
                            </Route>
                            <CleverRedirect from="*" to={NOT_FOUND} />
                        </Switch>
                    </App>
                </ CrystalsAppContainer>
            </Router>
        </Provider>,
        document.getElementById('root')
    )
}

interface CleverRedirectProps extends RedirectProps {
    routingStore?: RoutingStore
}

const CleverRedirect: React.FC<CleverRedirectProps> = inject(RoutingStore.storeName)(
    observer(
        props => {
            const { routingStore, ...other } = props

            console.debug(`CleverRedirect: redirecting from ${routingStore.location.pathname} to ${get(props.to, 'pathname', props.to)}`)

            return (
                <Redirect
                    {...other}
                />
            )
        }
    )
)

startApp()
